import { globalConstants } from '../_constants';

function global(state = {}, action) {
  switch (action.type) {
    case globalConstants.GLOBAL_ACCOUNT_SUCCESS:
      return {
        ...state,
        accounts: action.accounts,
        error: null
      };
    case globalConstants.GLOBAL_ACCOUNT_FAILURE:
      return {
        ...state,
        accounts: null,
        accountID: null,
        error: action.error
      };
    case globalConstants.GLOBAL_ACCOUNT_SELECT:
      return {
        ...state,
        accountID: action.account.id,
        accountName: action.account.name,
        error: null
      };
    case globalConstants.TIMEZONES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case globalConstants.TIMEZONES_SUCCESS:
      return {
        ...state,
        loading: false,
        timezones: action.timezones,
        error: null
      };
    case globalConstants.TIMEZONES_FAILURE:
      return {
        ...state,
        timezones: null,
        error: action.error
      };
    case globalConstants.GLOBAL_MACHINES_REQUEST:
      return {
        ...state,
        machines: [],
        loading: true
      };
    case globalConstants.GLOBAL_MACHINES_SUCCESS:
      return {
        ...state,
        loading: false,
        machines: action.machines,
        error: null
      };
    case globalConstants.GLOBAL_MACHINES_FAILURE:
      return {
        ...state,
        loading: false,
        machines: null,
        error: action.error
      };
    default:
      return state;
  }
}

export default global;
